
import _ from 'lodash';

const namespaced = true;

const state = {
  recurrentInterventions: [],
  isFetchingRecurrentInterventions: false,
};

const mutations = {
  SET_RECURRENT_INTERVENTIONS(state, recurrentInterventions) {
    state.recurrentInterventions = recurrentInterventions;
  },
  SET_IS_FETCHING_RECURRENT_INTERVENTIONS(state, isFetchingRecurrentInterventions) {
    state.isFetchingRecurrentInterventions = isFetchingRecurrentInterventions;
  },
};

const actions = {
  async fetchRecurrentInterventions({ commit, dispatch, rootState }) {
    commit(`SET_IS_FETCHING_RECURRENT_INTERVENTIONS`, true);
    let recurrentInterventions = [];
    try {
      const makerId = rootState[`model/client`].company.id;
      recurrentInterventions = await dispatch(`model/recurrentIntervention/fetchListForMaker`, makerId, { root: true });
    } catch (e) {} // eslint-disable-line

    commit(`SET_RECURRENT_INTERVENTIONS`, recurrentInterventions);
    commit(`SET_IS_FETCHING_RECURRENT_INTERVENTIONS`, false);
  },
};

const getters = {
  recurrentInterventions: state => _.orderBy(state.recurrentInterventions, [`nextAt`], [`asc`]),
  isFetchingRecurrentInterventions: state => state.isFetchingRecurrentInterventions,
};

export default {
  namespaced, state, mutations, actions, getters,
};
